<template>
    <div class="my-order" ref="container" style="padding-top: 1rem;">
        <navTitle
                v-bind:isback="false"
                title="BULLS-EYE"
                color="#4DADB5"
                font="#fff"

        ></navTitle>
        <!--<div class="game-tips" v-if="showTips">-->
        <!--A quick draw system will be used from 17:00 to 21:00-->
        <!--</div>-->
        <div class="game">
            <div class="shadow"></div>
            <div class="game_content">
                <div class="game_title" style="margin-bottom: 0rem;margin-top: 0.7rem">Chọn số may mắn của bạn</div>
                <div class="game_title"
                     style="margin-top: 0px;margin-bottom:0.2rem;font-size: 0.4rem;line-height: 0.5rem">đã
                    chọn:{{select_num_list.length}}/{{cart_num}}
                </div>
                <div class="game-tools">
                    <div class="tools-list" v-if="game_tools_list.length>0">
                        <div class="tools-item" @click="handleGameTools(item)" v-for="item in game_tools_list">
                            {{item}}
                        </div>
                    </div>
                </div>

                <div class="game_number_wrap">
                    <div
                            class="number_item"
                            :class="IsChoose(item)"
                            v-for="(item, index) in game_data"
                            :key="index"
                            @click="selectNumber(index, item)"
                    >
                        {{ item }}
                    </div>
                </div>
                <div class="game_footer" v-if="game_data">
                    <button class="submit" @click="submit">Xác nhận lựa chọn</button>
                </div>
            </div>
        </div>
        <gameTable :list="list"></gameTable>
        <div class="list">
            <div class="top">
                <div class="navitem">Thời gian mở cửa</div>
                <div class="navitem">Vấn đề</div>
                <div class="navitem">Con số</div>
                <div class="navitem">Kết quả</div>
            </div>
            <div class="live">
                <div class="ul" v-for="item in list">
                    <div class="li">{{ item.time }}</div>
                    <div class="li">{{ item.serial }}</div>
                    <div class="li">{{ item.number }}</div>
                    <div class="li">
                        <span>{{ item.result }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {guessOddList, saveOrder, get_game_config} from "@api/game";
    import {isDuringDate} from "@utils/time";
    import navTitle from "@components/navTitle";
    import gameTable from "@components/GameTable";

    import {MessageBox} from "mint-ui";

    const NAME = "game";
    export default {
        name: NAME,
        data() {
            return {
                id: "",
                cart_game_type: 'Phong tục',
                cart_num: 1,
                game_tools_list: ['ngẫu nhiên', 'xa lạ'],
                showTips: false,
                selectIndex: "",
                selectNum: "",
                select_num_list: [],//选择的数字数组
                area_index: 1,//区域模式默认从1开始
                mantissa_index: 1,//尾数模式默认从1开始
                game_data: [
                    1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
                    11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
                    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
                    31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
                    41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
                    51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
                    61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
                    71, 72, 73, 74, 75, 76, 77, 78, 79, 80,
                ], //游戏初始化数据
                list: [
                    // {
                    //   time:'01-22 22:40',
                    //   serial:'1',   //期号
                    //   number:"2564", //开奖号码
                    //   result:'偶数'
                    // }
                ]
            };
        },
        components: {
            navTitle,
            MessageBox,
            gameTable
        },

        watch: {
            $route(query) {
            }
        },
        methods: {
            setTips() {

                let date = new Date();
                let YYYY = date.getFullYear();
                let MM = date.getMonth() + 1;
                let DD = date.getDate();
                let time1 = `${YYYY}/${MM}/${DD} 17:00`
                let time2 = `${YYYY}/${MM}/${DD} 21:00`
                if (isDuringDate(time1, time2)) {
                    this.showTips = true
                } else {
                    this.showTips = false
                }
            },
            getList() {
                this.$dialog.loading.open("Loading...");

                guessOddList({
                    page: 1,
                    limit: 50,
                    type: this.$route.query.game_id
                })
                    .then(res => {
                        // console.log('list',res)
                        this.getGameConfig()

                        this.list = res.data;

                    })
                    .catch(() => this.$dialog.loading.close());
            },
            IsChoose(val) {
                let obj = {face: true}

                this.select_num_list.forEach(item => {
                    if (item == val) {
                        // console.log('----->',val)
                        obj = {click: true}
                        return obj
                    }
                })
                return obj
            },
            selectNumber(index, title) {
                this.selectIndex = index;
                this.selectNum = title;

                //加入到选择列表
                let list = this.select_num_list
                let total_num = this.cart_num

                let i = list.indexOf(title)
                if (i == -1) {
                    if (list.length >= total_num) {
                        list.splice(0, 1)
                    }
                    list.push(title)
                } else {
                    // console.log('iiii',i)
                    list.splice(i, 1)
                }
                this.$set(this, 'select_num_list', list)
            },
            submit() {
                if (!this.id) {
                    this.$dialog.error("error: orderid không tồn tại!");
                    return;
                }
                if (this.select_num_list.length == 0) {
                    this.$dialog.error("Vui lòng chọn một số");
                    return;
                }
                if (this.select_num_list.length < this.cart_num) {
                    this.$dialog.error("Vui lòng chọn tối thiểu " + this.cart_num + " Số");
                    return;
                }
                this.$dialog.loading.open("loading...");
                saveOrder({
                    order_id: this.id,
                    guess: this.select_num_list.join(',')
                })
                    .then(res => {
                        this.$dialog.loading.close();

                        // console.log('submit',res)
                        MessageBox.confirm("", {
                            closeOnClickModal: false,
                            title: res.status == 200 ? "thành công" : "lỗi",
                            message: res.msg,
                            showCancelButton: false,
                            confirmButtonText: "Xác nhận"
                        }).then(action => {
                            return this.$router.replace({
                                path: "/order/detail/" + this.id
                            });
                        });
                    })
                    .catch(res => {
                        this.$dialog.loading.close();
                        MessageBox.confirm("", {
                            title: res.status == 200 ? "thành công" : "lỗi",
                            closeOnClickModal: false,
                            message: res.msg,
                            showCancelButton: false,
                            confirmButtonText: "Xác nhận"
                        }).then(action => {
                            return this.$router.replace({
                                path: "/order/detail/" + this.id
                            });
                        });
                    });
            },
            getQueryVariable(variable) {
                var query = window.location.search.substring(1);
                var vars = query.split("&");
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split("=");
                    if (pair[0] == variable) {
                        return pair[1];
                    }
                }
                return false;
            },
            getRndInteger(min, max) {
                return Math.floor(Math.random() * (max - min + 1)) + min;
            },
            handleGameTools(name) {
                let that = this
                // console.log(name)
                var num = this.cart_num;
                var random_list = []

                switch (name) {
                    case 'ngẫu nhiên':
                        for (let i = 0; i < num; i++) {
                            let val = that.getRndInteger(1, 80)
                            if (random_list.indexOf(val) == -1) {
                                random_list.push(val)
                            } else {
                                i--
                            }
                        }
                        // console.log('random_list',random_list)
                        that.$set(that, 'select_num_list', random_list)
                        break;
                    case 'Nhỏ bé':
                        for (let i = 1; i <= 40; i++) {
                            random_list.push(i)
                        }

                        for (let i = 0; i < num - 40; i++) {
                            let val = that.getRndInteger(41, 80)
                            if (random_list.indexOf(val) == -1) {
                                random_list.push(val)
                            } else {
                                i--
                            }
                        }
                        // console.log('random_list',random_list)
                        that.$set(that, 'select_num_list', random_list)
                        break;
                    case 'To lớn':
                        for (let i = 41; i <= 80; i++) {
                            random_list.push(i)
                        }

                        for (let i = 0; i < num - 40; i++) {
                            let val = that.getRndInteger(1, 40)
                            if (random_list.indexOf(val) == -1) {
                                random_list.push(val)
                            } else {
                                i--
                            }
                        }
                        // console.log('random_list',random_list)
                        that.$set(that, 'select_num_list', random_list)
                        break;
                    case 'Diện tích':

                        for (let i = that.area_index, n = 0; n < 10; n++, i++) {
                            random_list.push(i)
                        }

                        for (let i = 0; i < num - 10; i++) {
                            let val = that.getRndInteger(1, 80)
                            if (random_list.indexOf(val) == -1) {
                                random_list.push(val)
                            } else {
                                i--
                            }
                        }
                        that.area_index = that.area_index + 10
                        if (that.area_index > 80) {
                            that.area_index = 1
                        }


                        that.$set(that, 'select_num_list', random_list)
                        break;
                    case 'Mantissa':

                        for (let i = that.mantissa_index, n = 0; n < 8; n++, i = i + 10) {
                            random_list.push(i)
                        }

                        for (let i = 0; i < num - 8; i++) {
                            let val = that.getRndInteger(1, 80)
                            if (random_list.indexOf(val) == -1) {
                                random_list.push(val)
                            } else {
                                i--
                            }
                        }
                        that.mantissa_index = that.mantissa_index + 1
                        if (that.mantissa_index > 10) {
                            that.mantissa_index = 1
                        }


                        that.$set(that, 'select_num_list', random_list)
                        break;
                    case 'xa lạ':
                        that.$set(that, 'select_num_list', []);
                        break;

                }
            },
            getGameConfig() {
                get_game_config(this.id).then(res => {
                    this.$dialog.loading.close();
                    let that = this
                    this.cart_game_type = res.data.cartType;
                    this.cart_num = res.data.total_num;
                    switch (res.data.cartType) {
                        case 'Phong tục':
                            that.$set(this, 'game_tools_list', ['ngẫu nhiên', 'xa lạ'])
                            break;
                        case 'Ngẫu nhiên':
                            that.$set(this, 'game_tools_list', ['ngẫu nhiên', 'xa lạ'])
                            break;
                        case 'To lớn':
                            that.$set(this, 'game_tools_list', ['ngẫu nhiên', 'To lớn', 'xa lạ'])
                            break;
                        case 'Nhỏ bé':
                            that.$set(this, 'game_tools_list', ['ngẫu nhiên', 'Nhỏ bé', 'xa lạ'])
                            break;
                        case 'Diện tích':
                            that.$set(this, 'game_tools_list', ['ngẫu nhiên', 'Diện tích', 'xa lạ'])
                            break;
                        case 'Mantissa':
                            that.$set(this, 'game_tools_list', ['ngẫu nhiên', 'Mantissa', 'xa lạ'])
                            break;
                        default:
                            that.$set(this, 'game_tools_list', ['ngẫu nhiên', 'xa lạ'])
                            break;
                    }
                }).catch(() => {
                    this.$dialog.loading.close();
                })
            }
        },
        getGameConfig_old() {
            get_game_config(this.id).then(res => {
                this.$dialog.loading.close();
                let that = this
                this.cart_game_type = res.data.cartType;
                this.cart_num = res.data.total_num;
                switch (res.data.cartType) {
                    case 'Custom':
                        that.$set(this, 'game_tools_list', ['ngẫu nhiên', 'xa lạ'])
                        break;
                    case 'Random':
                        that.$set(this, 'game_tools_list', ['random', 'clear'])
                        break;
                    case 'Big':
                        that.$set(this, 'game_tools_list', ['random', 'Big', 'clear'])
                        break;
                    case 'Small':
                        that.$set(this, 'game_tools_list', ['random', 'Small', 'clear'])
                        break;
                    case 'Area':
                        that.$set(this, 'game_tools_list', ['random', 'Area', 'clear'])
                        break;
                    case 'mantissa':
                        that.$set(this, 'game_tools_list', ['random', 'mantissa', 'clear'])
                        break;
                    default:
                        that.$set(this, 'game_tools_list', ['random', 'clear'])
                        break;
                }
            }).catch(() => {
                this.$dialog.loading.close();
            })
        },
        mounted() {
            this.id = this.getQueryVariable("id");
            this.getList();
            this.setTips();
        }
    };
</script>

<style scoped>

    .game {
        width: 100%;
        min-height: 9rem;
        background: url("../../../assets/images/game_number_bg.svg") repeat;
        -webkit-background-size: 10px;
        background-size: 90px;
        position: relative;
        overflow: hidden;
    }

    .shadow {
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.5);
        /*position: absolute;*/
        z-index: 1;
        top: 0px;
        left: 0px;
    }

    .game_content {
        /*position: absolute;*/
        width: 100%;
        height: 100%;
        z-index: 1000;
        top: 0px;
        left: 0px;
    }

    .game_title {
        width: 100%;
        line-height: 0.8rem;
        height: 0.8rem;
        text-align: center;
        font-size: 0.48rem;
        color: #24396b;
        margin-top: 0.6rem;
        margin-bottom: 0.6rem;
    }

    .game_number_wrap {
        width: 6.8rem;
        margin: 0 auto 0rem auto;

        flex-direction: column;
        display: flex;
        height: 9rem;
        flex-wrap: wrap;

        /*justify-content: space-around;*/
        /*padding: 0 0.3rem;*/
        box-sizing: border-box;
    }

    .game_number_wrap .number_item {
        width: 0.64rem;
        /*flex: 1;*/
        height: 0.64rem;
        line-height: 0.58rem;
        font-size: 0.35rem;
        margin-right: 0.2rem;
        margin-bottom: 0.2rem;
        background: #fac94f;
        color: #fff;
        border: 2px solid #e49608;
        text-align: center;
        text-shadow: 2px 2px 2px #e49608;
        /*display: inline-block;*/
        border-radius: 50%;
    }

    .game_number_wrap .number_item:nth-child(8n) {
        margin-right: 0px;
    }

    .game_number_wrap .number_item:last-child {
        margin-right: 0px;
    }

    .game_number_wrap .click {
        color: #395ba9;
        background: #fac94f;
        border: 2px solid #e49608;
        text-shadow: 2px 2px 2px #e49608;
        transform: scale(1.2);
    }

    .game_footer {
        width: 100%;
        margin-bottom: 0.6rem;
    }

    .submit {
        width: 2.9rem;
        height: 0.8rem;
        box-shadow: 2px 2px 5px #ccc;
        text-align: center;
        color: #fff;
        background: #fac94f;
        border-radius: 3px;
        margin: 0 auto;
        display: block;
        border: 2px solid #e49608;
        font-size: 0.36rem;
        animation: mymove 5s infinite;
        -webkit-animation: mymove 5s infinite;
        animation-direction: alternate;
        animation-timing-function: ease-in-out;
    }

    .list {
        width: 100%;
        margin: 0;
    }

    .list .top {
        width: 100%;
        height: 0.8rem;
        line-height: 0.8rem;
        display: flex;
        background: #faca51;
        text-shadow: 0px 0px 5px #fff;
    }

    .list .top .navitem {
        width: 25%;
        color: #1b3064;
        position: relative;
        text-align: center;
    }

    .list .top .navitem::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 50%;
        background: #1b3064;
    }

    .list .top .navitem:first-child:before {
        content: "";
        background: none;
    }

    .live {
        width: 100%;
        background: #fff;
    }

    .live .ul {
        width: 100%;
        height: 0.75rem;
        display: flex;
        border-bottom: 1px solid #f0f0f0;
        line-height: 0.75rem;
        color: #333;
    }

    .live .li {
        width: 25%;
        text-align: center;
    }

    .live .li span {
        width: 1.3rem;
        height: 0.5rem;
        line-height: 0.5rem;
        margin: 0.12rem auto;
        /*padding: 0.1rem 0px;*/
        text-align: center;
        display: block;
        border-radius: 0.05rem;
        background: #70d0d8;
        color: #fff;
    }

    .game-tips {
        width: 100%;
        height: 0.6rem;
        line-height: 0.6rem;
        background: rgba(255, 255, 255, 0.5);
        position: fixed;
        text-align: center;
        top: 1rem;
        left: 0px;
        right: 0px;
        z-index: 3000;
    }

    .game-tools {
        width: 6rem;
        margin: 0 auto 0.6rem auto;

    }

    .game-tools .tools-list {
        display: flex;
        border: 1px solid #e49608;
        height: 0.6rem;
        line-height: 0.6rem;
    }

    .game-tools .tools-title {
        height: 0.6rem;
        line-height: 0.6rem;
        font-size: 0.35rem;
        width: 100%;
        background: #fac94f;
        color: #fff;
        border: 2px solid #e49608;
        border-bottom: 1px dashed #e49608;
        text-align: center;
        text-shadow: 2px 2px 2px #e49608;
    }

    .game-tools .tools-item {
        flex: 1;
        font-size: 0.35rem;
        height: 0.6rem;
        line-height: 0.6rem;
        background: #fac94f;
        color: #fff;
        border: 1px solid #e49608;
        text-align: center;
        text-shadow: 2px 2px 2px #e49608;
    }

    @keyframes mymove {
        0% {
            transform: scale(1);
        }
        25% {
            transform: scale(1.1);
        }
        50% {
            transform: scale(1);
        }
        75% {
            transform: scale(1.1);
        }
    }

    @-webkit-keyframes mymove {
        0% {
            transform: scale(1);
        }
        25% {
            transform: scale(1.1);
        }
        50% {
            transform: scale(1);
        }
        75% {
            transform: scale(1.1);
        }
    }
</style>
